import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("lufso"), parcelRequire.load("fqSlw"), parcelRequire.load("hHkzJ"), parcelRequire.load("lo1tk"), parcelRequire.load("3btCG")]).then(() => {
let originalModule = parcelRequire("j5Ve0");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("lufso")} />
  <link rel="modulepreload" href={parcelRequire.resolve("fqSlw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hHkzJ")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("lo1tk")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3btCG")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
